export default function sum(
	countable: {
		reduce: (total: any, value: any) => any,
	},
	reducer = (value) => value,
): number {
	return countable.reduce((total, value) => total + reducer(value), 0);
}
